import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { QueryReturnValue } from 'services/api/base';
import { ReleaseList } from 'services/api/entities';
import {
  ErrorResponse,
  ReleaseListResponse,
} from 'services/api/responses/responseTypes';
import { fetchAndCombineSongsData } from 'services/store/helpers/fetchAndCombineSongsData';
import { transformToPaginatedList } from '../transformers';

const getReleases =
  (status?: string) =>
  async (
    page: number,
    _queryApi: unknown,
    _extraOptions: unknown,
    baseFetch: (arg: string) => Promise<QueryReturnValue<unknown, unknown>>
  ) => {
    const result = (await baseFetch(
      `/releases?page=${page}${status ? `&status=${status}` : ''}`
    )) as QueryReturnValue<ReleaseListResponse, ErrorResponse>;

    const { data, error } = result;

    if (error) {
      return {
        error: result.error as FetchBaseQueryError,
      };
    }

    const items = transformToPaginatedList(data);
    const songsWithPeaks = await fetchAndCombineSongsData(
      items.releases.flatMap((release) => release.songs)
    );

    return {
      data: {
        ...items,
        songs: songsWithPeaks,
      },
    };
  };

const createReleasesQuery = (status?: string) => ({
  queryFn: getReleases(status),
  serializeQueryArgs: ({ endpointName }: { endpointName: string }) =>
    endpointName,
  merge: (
    cache: ReleaseList,
    newItems: ReleaseList,
    { arg: page }: { arg: number | void }
  ) => {
    const currentCache = cache;
    if (page === 1) {
      currentCache.releases = [...newItems.releases];
    } else {
      currentCache.releases.push(...newItems.releases);
    }
    currentCache.areAllPagesLoaded = newItems.areAllPagesLoaded;
  },
  forceRefetch: ({
    currentArg = 1,
    previousArg = 1,
  }: {
    currentArg: number | void;
    previousArg: number | void;
  }) => currentArg > previousArg,
});

export default createReleasesQuery;
